import { useState } from 'react';
import { PageHeader } from '../ForBrands/ui/BrandUI';
import { Icon } from '../ForBrands/ui/icons';
import PaymentHistoryTab from './PaymentHistoryTab';
import InvoiceManagementTab from './InvoiceManagementTab';
import ManageTiersTab from './ManageTiersTab';
import PromoCodeManager from '../user/UserManagement/PromoCodeManager';

/**
 * Admin Payments Page - Tabbed interface for managing payments and invoices
 * Tabs:
 *  1. Payment History - View all user payment history with filters and pagination
 *  2. Manage Tiers - Apply, remove, grant trials for user tiers
 *  3. Invoice Management - Create and send custom invoices (Premium tier only)
 *
 * Note: Core & Pro tiers now use self-service Stripe checkout (no tier requests needed)
 *
 * AdminModeLayout draws the topbar, tabs and gutter; this page draws its
 * PageHeader and the tab strip over the four tab bodies.
 */
const TABS = [
  { id: 'payments', label: 'Payment history', icon: 'credit-card' },
  { id: 'invoices', label: 'Invoice management', icon: 'file-text' },
  { id: 'manage-tiers', label: 'Manage tiers', icon: 'award' },
  { id: 'promotions', label: 'Promotions', icon: 'tag' },
];

const AdminPaymentsPage = () => {
  const [activeTab, setActiveTab] = useState('payments');

  return (
    <div className="w-full min-w-0 max-w-full">
      <PageHeader eyebrow="Admin Mode" title="Payments" subtitle="Payment history, invoices, tiers and promotions." />

      <div className="mb-6 rounded-[12px] border border-bm-border bg-white">
        <div className="border-b border-bm-border">
          <nav role="tablist" aria-label="Payments sections" className="-mb-px flex overflow-x-auto">
            {TABS.map((tab) => {
              const active = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={active}
                  onClick={() => setActiveTab(tab.id)}
                  className={`-mb-px flex items-center gap-2 whitespace-nowrap border-b-2 px-5 py-3 font-archivo text-[15px] font-bold leading-5 ${active ? 'border-bm-orange text-bm-orange' : 'border-transparent text-bm-muted hover:text-bm-ink'}`}
                >
                  <Icon name={tab.icon} size={18} />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        <div className="p-6 sm:p-8">
          {activeTab === 'payments' && <PaymentHistoryTab />}
          {activeTab === 'manage-tiers' && <ManageTiersTab />}
          {activeTab === 'invoices' && <InvoiceManagementTab />}
          {activeTab === 'promotions' && <PromoCodeManager />}
        </div>
      </div>
    </div>
  );
};

export default AdminPaymentsPage;
